export default function ServiceArea() {
  const cities = [
    'Sarasota',
    'Venice',
    'Nokomis',
    'Osprey',
    'North Port',
    'Lakewood Ranch',
    'Bradenton'
  ];

  return (
    <section className="py-24 bg-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-slate-900 mb-4">
            Proudly Serving Southwest Florida
          </h2>
          <p className="text-xl text-gray-600">
            Fast, Reliable HVAC Service Across Sarasota County
          </p>
        </div>

        {/* Map Illustration */}
        <div className="relative max-w-4xl mx-auto mb-16">
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/4c9a32f58b025bf5f4e77ef467b993b7.jpg"
              alt="Service Area Map"
              className="w-full h-auto rounded-3xl shadow-lg"
            />
            
            {/* City Badges Overlay */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 p-8">
                {cities.map((city, index) => (
                  <div
                    key={index}
                    className="bg-white border-2 border-orange-500 rounded-full px-6 py-3 text-center shadow-lg hover:bg-orange-500 hover:text-white transition-all cursor-pointer transform hover:scale-105"
                  >
                    <p className="font-bold text-slate-900 hover:text-white whitespace-nowrap">
                      {city}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* City List */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {cities.map((city, index) => (
            <div
              key={index}
              className="bg-white border-2 border-orange-500 rounded-full px-8 py-4 shadow-md hover:bg-orange-500 hover:text-white transition-all cursor-pointer group"
            >
              <p className="font-bold text-slate-900 text-lg group-hover:text-white whitespace-nowrap">
                {city}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Text */}
        <div className="text-center bg-white rounded-2xl p-8 shadow-md max-w-3xl mx-auto">
          <p className="text-xl text-gray-700">
            Don't see your city?{' '}
            <a 
              href="tel:9412233052" 
              className="text-orange-500 font-bold hover:text-orange-600 transition-colors cursor-pointer"
            >
              Call us at (941) 223-3052
            </a>
            {' '}- We may still service your area!
          </p>
        </div>
      </div>
    </section>
  );
}